/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */
import './Banner.scss';

import { noop } from '@boi/core/lib/utils';
import type { Node } from 'react';
import React, { Children } from 'react';

interface Props {
  children: noop;
}

const className = 'c-Banner';
const Banner = ({ children }: Props) => {
  return (
    <div className={className}>
      {Children.map(
        children,
        (child: Node) =>
          child && <div className={`${className}__banner`}>{child}</div>
      )}
    </div>
  );
};
export default Banner;
